import React, { useMemo, useState } from "react";
import Form, {
  Item,
  GroupItem,
  RequiredRule,
  StringLengthRule,
  Label,
} from "devextreme-react/form";
import { formatMessage } from "devextreme/localization";
import Guid from "devextreme/core/guid";
import moment from "moment";
import notify from "devextreme/ui/notify";
import LoadPanel from "devextreme-react/load-panel";
import { useAuth } from "../../../contexts/auth";
import { axios } from "../../../common";
import "./style.scss";
import { convertTimeToDateTime } from "../../../services/overtime";

export default function FormOvertimeRegistration({
  formData,
  setShiftTimeIn,
  shift,
  setShiftTimeOut,
  employee,
  employeeOid,
  setIsAssignedShift,
  isDisableShift,
}) {
  const [loading, setLoading] = useState(false);
  const { user } = useAuth();

  const shiftDisplayExpr = useMemo(
    () => (item) => item && `${item.Code} - ${item.Name}`,
    []
  );

  const employeeData = useMemo(
    () => employee.find((item) => item.Oid === employeeOid),
    [employeeOid, employee]
  );

  const handleGetShift = async (empOid) => {
    if (!formData.current.OvertimeDate) return;
    try {
      if (!user) {
        notify("Không có nhân viên nào được chọn", "error", 3000);
        return;
      }
      const date = moment(new Date(formData.current.OvertimeDate)).format();

      const payload = {
        EmployeeOid: empOid,
        WorkingDate: date,
      };
      const { data } = await axios.post("GetShiftAssign", payload);
      const { Shift, EmployeeOid } = data;
      if (Shift !== null) {
        formData.current.Shift = {
          Oid: new Guid(Shift.Oid),
          TimeIn: convertTimeToDateTime(Shift.TimeIn),
          TimeOut: convertTimeToDateTime(Shift.TimeOut),
          RestStart: convertTimeToDateTime(Shift.RestStart),
          RestEnd: convertTimeToDateTime(Shift.RestEnd),
          Code: Shift.Code,
          Name: Shift.Name,
        };
      }
      setLoading(false);
      setLoading(true);
      formData.current.Employee = {
        Oid: EmployeeOid ? EmployeeOid : empOid,
      };

      setLoading(false);
    } catch (error) {
      console.error(error);
      notify(
        "There was an error while getting shift information. Please try again.",
        "error",
        3000
      );
    }
  };

  const PositionNameEditorOptions = {
    value: employeeData?.PositionName,
    disabled: true,
  };
  const DepartmentNameEditorOptions = {
    value: employeeData?.DepartmentName,
    disabled: true,
  };
  return (
    <div>
      <LoadPanel visible={loading} />
      <Form
        colCount={2}
        id="form-overtime"
        formData={formData.current}
        className={"form-editor mb-2"}
        onContentReady={(e) => {
          e.component.focus();
        }}
      >
        <GroupItem>
          <Item
            dataField="OvertimeDate"
            editorType="dxDateBox"
            editorOptions={{
              displayFormat: "dd/MM/yyyy",
              onValueChanged: (e) => {
                handleGetShift(employeeOid);
                setLoading(true);
              },
            }}
          >
            <Label text={formatMessage("OvertimeDate")} />
            <RequiredRule message={formatMessage("ValidateOvertimeDate")} />
          </Item>
        </GroupItem>
        <GroupItem>
          <Item
            dataField="Shift"
            editorType="dxSelectBox"
            editorOptions={{
              dataSource: shift,
              displayExpr: shiftDisplayExpr,
              disabled: isDisableShift,
              // valueExpr: "Oid",
              value: formData.current.Shift,
              onValueChanged: ({ value }) => {
                // setCheckBreakTime(false);
                formData.current.IsBreakTime = false;

                const timeIn = convertTimeToDateTime(value?.TimeIn);
                const timeOut = convertTimeToDateTime(value?.TimeOut);
                const restStart = convertTimeToDateTime(value?.RestStart);
                const restEnd = convertTimeToDateTime(value?.RestEnd);

                setShiftTimeIn(timeIn);
                setShiftTimeOut(timeOut);

                formData.current.Shift = {
                  Oid: value?.Oid,
                  TimeIn: timeIn,
                  TimeOut: timeOut,
                  Code: value?.Code,
                  Name: value?.Name,
                  RestStart: restStart,
                  RestEnd: restEnd,
                };
              },
            }}
          >
            {/* <RequiredRule message={formatMessage("ValidateShift")} /> */}
            <Label text={formatMessage("Shift")} />
          </Item>
        </GroupItem>
        <GroupItem>
          <Item
            dataField="PositionName"
            editorOptions={PositionNameEditorOptions}
          >
            <Label text={formatMessage("PositionName")} />
          </Item>
          <Item
            dataField="DepartmentName"
            editorOptions={DepartmentNameEditorOptions}
          >
            <Label text={formatMessage("DepartmentName")} />
          </Item>
        </GroupItem>
        <Item
          dataField="Reason"
          editorType="dxTextArea"
          editorOptions={{ height: 80, width: "100%" }}
        >
          <RequiredRule />
          <StringLengthRule max="250" />
          <Label text={formatMessage("Reason")} />
        </Item>
      </Form>
    </div>
  );
}
